import React, { PureComponent } from 'react';
import './login-frame.less';

class LoginFrame extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            loginType: 'password'
        };
    }

    componentDidMount() {
        const bg = document.getElementById('bg-hlb');
        const bgWrapper = document.getElementsByClassName('hlb-login-bg-v5')[0];
        bg.onload = () => {
            bgWrapper.style.visibility = 'visible';
        }
    }

    render() {
        return (
            <div className='login-frame'>
                <div className="hlb-login-bg-v5"></div>
                <img id="bg-hlb" src="https://oss.zhongbaounion.com/share/background/hlb_bg.jpg" />
                <div className='login'>
                    {/* <div className='left'>&nbsp;</div> */}
                    <div className='left'>
                        <div className="content-box">
                            <div className="text-box">
                                <img className="desc-img" src={require('../../../img/hlb_login-bg_desc.png')} alt=""/>
                                {/*<p className="title">让保险经营更简单</p>*/}
                                {/*<p className="desc">提供全链条数字化服务  成为保险经营者最信赖的伙伴</p>*/}
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <div className='inputArea'>
                            {this.props.children}
                        </div>
                    </div>
                </div>
                <div className='footer'>
                    <div className="copyright">
                        Copyright© 2022 广州海保科技有限责任公司
                        {/*粤ICP备20011448号*/}
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginFrame;
